(function () {
  'use strict';

  document.addEventListener('dragstart', function (e) {
    if (e.target.closest('.scroll-area, .product-list, slideshow-carousel, scroll-carousel, [data-drag-scroll]')) {
      e.preventDefault();
    }
  });

  var DRAG_THRESHOLD = 6;

  function settleToNearest(container, direction) {
    var box = container.getBoundingClientRect();
    var pad = parseFloat(getComputedStyle(container).scrollPaddingInlineStart) || 0;
    var target = container.scrollLeft;
    var best = Infinity;
    Array.prototype.forEach.call(container.children, function (child) {
      var delta = child.getBoundingClientRect().left - box.left - pad;
      if (direction > 0 && delta <= 1) return;
      if (direction < 0 && delta >= -1) return;
      if (Math.abs(delta) < best) {
        best = Math.abs(delta);
        target = container.scrollLeft + delta;
      }
    });
    var max = container.scrollWidth - container.clientWidth;
    target = Math.max(0, Math.min(max, target));

    container.classList.add('is-settling');
    container.scrollTo({ left: target, behavior: 'smooth' });

    var done = function () {
      container.classList.remove('is-settling');
      container.removeEventListener('scrollend', done);
    };
    container.addEventListener('scrollend', done);
    setTimeout(done, 600);
  }

  function initDragScroll(container) {
    if (container.__dragScrollInit) return;
    container.__dragScrollInit = true;

    var isDown = false;
    var isDragging = false;
    var startX = 0;
    var lastDiff = 0;
    var scrollStart = 0;

    container.addEventListener('pointerdown', function (e) {

      if (e.pointerType !== 'mouse' || e.button !== 0) return;

      isDown = true;
      isDragging = false;
      startX = e.clientX;
      scrollStart = container.scrollLeft;
      container.classList.add('is-grabbing');
    });

    container.addEventListener('pointermove', function (e) {
      if (!isDown) return;

      var diff = e.clientX - startX;

      if (!isDragging && Math.abs(diff) > DRAG_THRESHOLD) {
        isDragging = true;
        container.setPointerCapture(e.pointerId);
      }

      if (isDragging) {
        e.preventDefault();
        container.scrollLeft = scrollStart - diff;
        lastDiff = diff;
      }
    });

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;
      container.classList.remove('is-grabbing');

      if (isDragging) {
        if (container.hasAttribute('data-drag-scroll')) {
          var direction = Math.abs(lastDiff) > 40 ? (lastDiff < 0 ? 1 : -1) : 0;
          settleToNearest(container, direction);
        }

        var blockClick = function (evt) {
          evt.stopPropagation();
          evt.preventDefault();
        };
        container.addEventListener('click', blockClick, { capture: true, once: true });
        setTimeout(function () {
          container.removeEventListener('click', blockClick, { capture: true });
        }, 50);
      }
      isDragging = false;
    }

    container.addEventListener('pointerup', endDrag);
    container.addEventListener('pointercancel', endDrag);
    container.addEventListener('pointerleave', endDrag);
  }

  function initAll() {
    document.querySelectorAll('.scroll-area, [data-drag-scroll]').forEach(initDragScroll);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', initAll);

  var observer = new MutationObserver(function () {
    initAll();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
